import { GetAppMetricsAverageSummaryWholeTeamQuery } from '../../../../../src/interface/queries/team-metrics/summary/get-app-metrics-average-summary-whole-team.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAppMetricsAverageSummaryWholeTeamRequestDto } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-average-summary-whole-team.request.dto';
import { GetAppMetricsAverageSummaryWholeTeamResponseArray } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-average-summary-whole-team.response.dto';
import { AppMetricsAverageSummaryWholeTeamAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/summary/app-metrics-average-summary-whole-team.aggregate-root.mapper';

export class GetAppMetricsAverageSummaryWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsAverageSummaryWholeTeamQuery,
    protected readonly mapper: AppMetricsAverageSummaryWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetAppMetricsAverageSummaryWholeTeamRequestDto
  ): Promise<GetAppMetricsAverageSummaryWholeTeamResponseArray> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `AppMetricsAverageSummaryWholeTeamController.get encountered an error: ${error}`
      );
    }
  }
}
